// extracted by mini-css-extract-plugin
export default {"menuBlock":"LF-z","title":"MF-z","nav":"NF-z","flexCell":"OF-z","facetLink":"PF-z"};